import urls from "../../../global/constants/UrlConstants";
import { getCallParams, makeCall, makeCallFile } from "../../../utils/service";

// ─── Generate (phase analysis) ────────────────────────────────────────────────
export const generateProfessionPhasedAnalysis = async (
  profileId: string,
  language: string,
  prompt: string,
  phase: number,
  previousMarkdown?: string,
): Promise<any> => {
  const body: any = { profileId, language, prompt, phase, maxTokens: 8000 };
  if (previousMarkdown) body.previousMarkdown = previousMarkdown;
  const callParams = await getCallParams("POST", body);
  return makeCall(urls.professionPhasedPhase, callParams);
};

// ─── Save prompt for a phase (no profileId — prompts are global templates) ───
export const savePhasePrompt = async (
  phase: number,
  prompt: string,
): Promise<any> => {
  const body = { prompt };
  const url = `${urls.professionPhasedPrompt}/${phase}`;
  const callParams = await getCallParams("POST", body);
  return makeCall(url, callParams);
};

// ─── Download final DOCX (payload: { markdown }) ─────────────────────────────
export const downloadPhasedAnalysis = async (
  markdown: string,
): Promise<Blob> => {
  const body = { markdown };
  const callParams = await getCallParams("POST", body);
  return makeCallFile(urls.professionPhasedDownload, callParams);
};

// ─── Get saved prompt for a specific phase ────────────────────────────────────
export const getSavedPrompts = async (phase: number): Promise<any> => {
  const url = `${urls.professionPhasedPrompt}/${phase}`;
  const callParams = await getCallParams("GET");
  return makeCall(url, callParams);
};
